export default {
    translation: {
        sidebar: {
            btnHome: 'Menü',
            btnLogin: 'Einloggen',
            btnRegister: 'Registrieren',
            btnUpdateUserInfo: 'Kontaktdaten',
            btnAddressMgr: 'Adressen',
            btnUpdatePassword: 'Passwort',
            btnLogout: 'Ausloggen',


            lbNotLogin: 'Nicht eingeloggt',
        },
        shortcutCartMobile: {
            btnOpenMenu: 'Menü',
            btnCloseMenu: 'Schließen',
            btnNext: 'Weiter',

            lbDishCount1: '{{count}} Artikel',
            lbDishCountn: '{{count}} Artikel',
        },
        foodMobile: {
            btnAdd: 'Hinzufügen',
            btnNote: 'Hinweis',
            btnMoreInfo: 'Produktinfo',
            btnSeeMore: 'Mehr anzeigen',
            btnCollapse: 'Einklappen',
            soldOut: 'Ausverkauft',

            lbOptional: 'Wahlweise',
            lbDishCount1: '{{count}} Portion',
            lbDishCountn: '{{count}} Portionen',
        },
        headerMobile: {
            lbSearchFood: 'Artikel suchen...',
        },
        modalNoteMobile: {
            title: 'Hinweis',

            btnSave: 'Merken',
        },
        modalFastEditMobile: {
            btnAddOther: 'Weitere Portion',
            btnChange: 'Ändern',
            btnOK: 'OK',

            lbDefault: '',
        },
        modalFoodDetailsMobile: {
            btnAddToCart: 'Hinzufügen',
            btnUpdateCart: 'Aktualisieren',

            lbNote: 'Hinweis',
        },
        modalMoreInfo: {
            title: 'Produktinfo',
        },
        modalOrderMethod: {
            title: 'Liefern lassen oder Mitnehmen',
            titleSearchAddress: 'Ihre Adresse',

            lbDeliver: 'Lieferung',
            lbPickup: 'Abholung',
            lbHadAccount: 'Haben Sie bereits ein Konto?',
            lbAddressSaved: 'Adressen',

            mesWebOrderUnSupport: 'Online-Bestellservice wird nicht unterstützt!',
            mesOutsideShippingSupportArea: 'Wir liefern im Umkreis von {{distance}}km.\nBitte rufen Sie uns zum Bestellen!',
            btnNext: 'Weiter',
        },
        modalTableOrderMethod: {
            title: '',
            lbAtRestaurant: 'Hier essen',
            lbTakeAGo: 'Zum Mitnehmen',
        },
        modalOverTime: {
            message: 'Sie sind außerhalb der Öffnungszeiten',
            btnAgree: 'OK',

            messageNotReady: 'Wir sind bald wieder für Sie da!',
            messageTodayOff: 'Wir haben heute geschlossen!',
            messageTimeworkFrame1: 'Sie sind außerhalb der Öffnungszeiten.\nWir haben heute von\n{{from}} - {{to}} Uhr geöffnet.',
            messageTimeworkFrame2: 'Sie sind außerhalb der Öffnungszeiten.\nWir haben heute geöffnet von\n{{from1}} - {{to1}} und {{from2}} - {{to2}} Uhr.'
        },
        modalPayWithPaypal: {
            title: 'Zahlung per Paypal',
            btnPayWithCash: 'Zahlung per Bargeld',
            btnPayWithEC: 'EC bei Auslieferung'
        },
        modalExpireOrderSession: {
            message: 'Ihre Sitzung ist abgelaufen. Bitte scannen Sie den QRCode erneut!',
            title: 'Achtung',
            btnAgree: 'OK',
        },
        cartMobile: {
            title: 'Warenkorb',

            lbTotalAmount: 'Gesamt',
            lbTableNumber: 'Tischnr.',
            lbCartEmpty: 'Ihr Warenkorb ist leer',
            lbCash: 'Bargeld',
            lbCashCard: 'Kartenzahlung',
            lbDeliver: 'Lieferung',
            lbPickup: 'Abholung',
            lbOrderMethod: 'Wie wollen Sie Ihre Bestellung erhalten?',
            lbCustomerName: 'Name',
            lbNote: 'Hinweis',
            lbSelectDeliverTime: 'So schnell wie möglich',
            lbPayWithEC: 'EC bei Auslieferung',
            lbGroupOrder: 'Packung {{group}}',
            lbShippingPrice: 'Lieferkosten',

            btnStartOrder: 'Weiter',
            backToMenu: 'Zurück zum Menü',
            btnSubmitOrder: 'Bestellen',
            btnRequestPayment: 'Zahlungsaufforderung',
            btnAddGroupOrder: 'nächste Packung',

            mesRequestPaymentSuccess: 'Zahlungsaufforderung erfolgreich',
            mesRequestSupportSuccess: 'Gọi nhân viên hỗ trợ thành công',
            mesMinTotalMoneyRequire:
                'Mindestbestellwert von {{minValue}}',
            mesSubmitOrderTakeAGoSuccess:
                'Vielen Dank, Ihre Bestellung wurde erfolgreich aufgegeben.',
        },
        modalOrderSuccess: {
            titleSubmitOrderSuccess: 'Bestellung wurde aufgegeben',
            titleRestaurantDoneOrder: 'Bestellung ist fertig',
            titleProcessing: 'Bestellung wird vorbereitet',
            titleAccepted: 'Bestellung ist eingegangen',
            titleFailed: 'Bestellung wurde storniert',
            lbTotal: 'Gesamt',
            lbShippingPrice: 'Lieferkosten',
            mesSubmitOrderWebSuccess: 'Vielen Dank, Ihre Bestellung wurde erfolgreich aufgegeben.',
            mesSubmitOrderSuccess: 'Bestellerfolg',
            mesAccepted: 'Ihre Bestellung ist eingegangen.',
            mesProcessing: 'Ihre Bestellung wird vorbereitet, bitte warten Sie.',
            mesDonePickup: 'Ihre Bestellung ist fertig. Bitte holen Sie Ihre Bestellung ab!',
            mesDoneDeliver: 'Ihre Bestellung wird geliefert.',
            mesDoneAtRestaurant: 'Ihre Bestellung ist fertig. Bitte holen Sie Ihre Bestellung ab!',
            mesFailed: 'Ihre Bestellung wurde storniert.',
            mesTabletDoneSubmit: 'Bitte bezahlen Sie Ihre Bestellung!',

            lbDiscount: 'Rabatt',
            hintDontCloseTab: 'Bitte dieses Fenster nicht schließen!'
        },
        footer: {
            lbContact: 'Kontakt',
            lbCopyright: '© 2021 {{someone}}',
        },
        cartDesktop: {
            title: 'Warenkorb',

            lbCartEmpty: 'Ihr Warenkorb ist leer',
            lbAgreeTCPre: 'Durch Anklicken von Zahlungspflichtig bestellen bestätigst Du den Warenkorb und Deine eingegebenen Daten und stimmst unseren',
            lbAgreeTCRest: 'zu.',
            lbTermAndCondition: 'Datenschutzbestimmungen sowie AGB',
            lbDeliver: 'Lieferung',
            lbPickup: 'Abholung',
            lbOrderMethod: 'Wie wollen Sie Ihre Bestellung erhalten?',
            lbTotalAmount: 'Gesamt',
            lbCash: 'Bargeld',
            lbPaymentMethod: 'Zahlungsmethode',
            lbCustomerName: 'Name',
            lbDeliverInfo: 'Hinweise für diese Bestellung',
            lbNote: 'Hinweis',
            lbSelectDeliverTime: 'So schnell wie möglich',
            lbPayWithEC: 'EC bei Auslieferung',
            lbShippingPrice: 'Lieferkosten',
            mesMinTotalMoneyRequire:
                'Mindestbestellwert von {{minValue}}',

            btnStartOrder: 'Bestellen',
            btnSubmitOrder: 'Zahlungspflichtig bestellen',
            btnAddGroupOrder: 'nächste Packung',
            btnAgree: 'Merken'
        },
        headerDesktop: {
            btnUpdateUserInfo: 'Kontaktdaten',
            btnUpdatePassword: 'Passwort ändern',
            btnLogout: 'Ausloggen',
            btnLogin: 'Einloggen',
            btnRegister: 'Registrieren',
            btnAddressMgr: 'Adressen'
        },
        button: {
            agree: 'OK',
            update: 'Aktualisieren',
            register: 'Registrieren',
            forgotPassword: 'Passwort vergessen',
            login: 'Einloggen',
            confirm: 'Absenden',
            moreInfo: 'Produktinfo',
            requestPayment: 'Zahlungsaufforderung',
            back: 'Zurück',
        },
        voucher: {
            discountCode: 'Rabattcode',
            btnVerify: 'Prüfen',
            verified: 'Geprüft',
            invalidVoucher: 'Ungültiger Rabattcode',
            minOrderNotMet: 'Mindestbestellwert {{minValue}} für diesen Code erforderlich',
            voucherVerified: 'Rabattcode akzeptiert!',
            voucherDetails: 'Gutscheindetails',
        },
        customerInfo: {
            username: 'Benutzername',
            password: 'Kennwort',
            confirmPassword: 'Kennwort bestätigen',
            newPassword: 'Neues Kennwort',
            confirmNewPassword: 'Neues Kennwort bestätigen',
            firstName: 'Name',
            phone: 'Telefonnummer',
            email: 'Email',
            office: 'Firmenname',
            street: 'Straße',
            apartmentNumber: 'Hausnummer',
            postCode: 'Postleitzahl',
            city: 'Stadt',
            floor: 'Etage',
            address: 'Wohin sollen wir Ihre Bestellung liefern?',
            personalInformation: 'Persönliche Daten',
            contactInfo: 'Wie können wir Sie kontaktieren?',
            otp: 'OTP',
            cash: 'Bargeld',
            card: 'Girocard mit PIN',
            cash_card: 'Kartenzahlung',
            delivery: 'Lieferung',
            pickup: 'Abholung',
            deliveryTime: 'Gewünschte Lieferzeit',
            pickupTime: 'Gewünschte Abholzeit',
            paymentMethod: 'Zahlungsmethode',
            payment: 'Zahlungsmethode',

            lbSelectAddress: 'Gespeicherte Adresse',
            lbDefaultSelectAddress: 'Neue Adresse eingeben',
            paymentMethodGroupCash: 'Nach Erhalt zahlen',
            paymentMethodGroupOnline: 'Bezahle online',
        },
        // for mobile page and desktop modal
        updatePassword: {
            title: 'Passwort ändern',
        },
        // page and modal
        forgotPassword: {
            title: 'Passwort zurücksetzen',
            titleNewPassword: 'Neues Kennwort',

            mesChangeSuccess: 'Ihr Kennwort wurde erfolgreich aktualisiert!',
        },
        // register page and update personal info page
        personalInfo: {
            titleRegister: 'Account erstellen',
            titleUpdate: 'Persönliche Daten',
        },
        orderDetails: {
            totalAmount: 'Gesamt',
        },
        modalFoodChoose: {
            title: 'Aktuelle Auswahl:',
            btnAgree: 'Auswählen',

        },
        message: {
            minTotalMoneyRequire: 'Mindestbestellwert von {{minValue}}',
            mesOutsideShippingSupportArea: 'Wir liefern im Umkreis von {{distance}}km.\nBitte rufen Sie uns zum Bestellen!',
            messageInvalidTable: 'Der Tisch ist nicht buchbar.',
            tabletQRCodeScannedBySomeone:'Bitte scannen Sie den QR Code nochmal!',
            beilageRequire: 'Bitte wählen Sie eine Beilage von "{{group}}"',
            waiting: 'Bitte warten...',
            invalidTable: 'QRCode ist abgelaufen!',
            registerSuccess: 'Registrieren erfolgreich',
            updateUserInfoSuccess: 'Aktualisierung erfolgreich',
            invalidAddress: 'Ungültige Adresse',
            invalidRestaurant: 'Ungültige ID',
            invalidEmail: 'Ungültige E-Mail',
            fieldRequired: 'Dieses Feld darf nicht leer gelassen werden',
            minLength: 'Dieses Feld muss mindestens {{minLength}} Zeichen enthalten',
            confirmPasswordNotMatch: 'Falsches Kennwort',
            invalidQRCode: 'QR Code ist abgelaufen!',
            unSupportDevice: 'Gerät wird nicht unterstützt!',
            unSupportService: 'Dienst wird nicht unterstützt!',
            dataNotFound: 'Daten wurde nicht gefunden',
            alreadyScan: 'Sie bestellen gerade von einem anderen Tisch, daher ist dieser neue Tisch nicht mehr buchbar!'
        },
        addressMgr: {
            title: 'Adressen',
            titleAdd: 'Adresse hinzufügen',
            lbEmptyAddress: 'Keine Adresse',
            lbStreet: 'Straße',
            lbAddressNumber: 'Hausnr.',
            lbZipCode: 'Postleitzahl',
            lbCity: 'Stadt',
            lbFloor: 'Etage',
            lbAddress: 'Adresse',
            lbPhone: 'Telefonnummer',
            btnAddAddress: 'Adresse hinzufügen',
            btnAdd: 'Hinzufügen',
            btnUpdate: 'Ändern',
            btnCancel: 'Abbrechen',
            btnEdit: 'Adresse ändern',
            btnDelete: 'Adresse entfernen',
            btnAgree: 'Adresse entfernen',
            lbConfirmDelete: 'Möchten Sie die ausgewählte Adresse wirklich löschen?',
            mesAddressInvalid: 'Ungültige Adresse',
            mesUpdateAddressFailed: 'Adressaktualisierung fehlgeschlagen',

        },
        tableQrcodeSuccess: {
            continueOrder: 'Đặt tiếp',
            viewOrder: 'Xem lại',
            supporter: 'Nhân viên hỗ trợ',
            requestPayment: 'Gọi tính tiền',

            mesSubmitOrderFirst: 'Vui lòng đặt hàng rồi mới yêu cầu tính tiền',

            btnAgreeReqPmt: 'Đồng ý',
            btnCancel: 'Huỷ',
        },
        tableQrcodePrinter: {
            title: 'Printers'
        },
        apiMessage: {
            registerFailed: 'Die Registrierung war leider nicht erfolgreich. Bitte achten Sie darauf, dass alle Pflichtfelder ausgefüllt sind!', 
            requestForgetPasswordFailed: 'Anfrage auf Zurücksetzen des Passworts ist fehlgeschlagen. Bitte überprüfen Sie nochmals die fehlenden Angaben!', 
            changePasswordSuccess: 'Passwortänderung war erfolgreich!', 
            changePasswordFailed: 'Das Ändern des Passworts ist fehlgeschlagen. Stellen Sie sicher, dass Ihre Angaben korrekt sind!', 
            updateProfileFailed: 'Aktualisieren des Profils fehlgeschlagen. Achten Sie darauf, dass alle notwendigen Angaben ausgefüllt sind!',
            customerRequestPaymentFailed: 'Die Durchführung Ihrer Zahlung konnte nicht bearbeitet werden!', 
            loginFailed: 'Probleme bei der Anmeldung in Ihrem Konto. Überprüfen Sie Ihre Angaben und versuchen es erneut!', 
            saveOrderFailed: 'Ihr Bestellprozess wurde abgebrochen oder konnte nicht durchgeführt werden', 
            orderExpired: 'Ihre Bestellung ist abgelaufen.\nBitte scannen Sie den QRCode erneut!',
            undefinedError: 'Unbekannter Fehler', 
            orderInvalid: 'Ungültiger Pfad',
            getOrderDetailsFailed: 'Ihre Bestelldaten konnten nicht aufgerufen werden!', 

        }
    },
}
